import type { SystemStyleObject } from '@chakra-ui/theme-tools';

const BreadcrumbTheme: SystemStyleObject = {
  baseStyle: {
    item: {
      _last: {
        minWidth: 0,
      },
    },
    link: {
      _activeLink: {
        _hover: {
          textDecoration: 'none',
        },
        color: 'neutral.10',
      },
      _hover: {
        textDecoration: 'underline',
      },
      color: 'purple.50',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    list: {
      alignItems: 'center',
      display: 'flex',
    },
    separator: {
      color: 'neutral.80',
      display: 'flex',
    },
  },
};

export default BreadcrumbTheme;
